var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFastRepair = function SvgFastRepair(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3935 24.4122C42.5187 34.0713 34.7901 42.003 25.131 42.1282C19.1637 42.2056 13.8556 39.2853 10.6403 34.7641",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99016 23.5981C5.86494 13.9391 13.5936 6.00738 23.2526 5.88215C29.3664 5.8029 34.7881 8.87017 37.9762 13.5819",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0174 19.4211C22.4554 18.9832 22.4554 18.2731 22.0174 17.8352L18.6108 14.3667C18.1689 13.9248 19.0236 13.2015 19.6482 13.1797C19.8242 13.1736 20.0058 13.1724 20.1967 13.1724C23.6478 13.1724 26.4454 15.97 26.4454 19.4211C26.4454 20.2897 26.2682 21.117 25.9479 21.8686L33.4603 29.705C34.3522 30.6354 34.3291 32.1104 33.4084 33.0123C32.474 33.9276 30.9724 33.9046 30.0665 32.9613L22.6032 25.1896C21.8625 25.4989 21.0496 25.6698 20.1967 25.6698C16.7456 25.6698 13.948 22.8721 13.948 19.4211C13.948 19.2563 13.949 19.0984 13.9533 18.945C13.9712 18.3164 14.8156 17.3906 15.2602 17.8352L18.6108 21.2987C19.0487 21.7366 19.7588 21.7366 20.1967 21.2987L22.0174 19.4211Z",
    stroke: "black",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5464 13.2051C18.9219 13.2269 17.8379 14.2079 18.4755 14.9408L21.5042 17.9697C21.9421 18.4077 21.9421 19.1177 21.5042 19.5557L19.5464 21.5387M15.2304 17.8393C14.3398 17.4511 13.9712 18.8044 13.9533 19.433C13.949 19.5864 13.948 19.7443 13.948 19.9091C13.948 23.3602 16.7456 26.1578 20.1967 26.1578C20.6887 26.1578 21.1674 26.1009 21.6266 25.9934C22.2296 25.8523 22.886 25.972 23.315 26.4188L30.0665 33.4493C30.9724 34.3926 32.474 34.4156 33.4084 33.5003C34.3291 32.5984 34.4825 30.7357 33.5905 29.8053",
    stroke: "black",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6501 30.9697C31.4925 30.9697 31.3647 31.0975 31.3647 31.2551C31.3647 31.4127 31.4925 31.5405 31.6501 31.5405C31.8078 31.5405 31.9355 31.4127 31.9355 31.2551C31.9355 31.1231 31.8459 31.0121 31.7242 30.9794",
    stroke: "black",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4927 14.5455L32.2889 13.6423L38.5462 13.5612L37.6234 6.47598L39.4927 14.5455Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54573 33.797L17.0551 34.6539L11.0565 35.3664L11.7858 42.2369L9.54573 33.797Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFastRepair);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fast_repair.86f0b77ba24f31db766a1f7bbc970363.svg";